<template>
    <svg aria-hidden="true" focusable="false" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="22.5" r="22" fill="white" stroke="#9D9FA2" />
        <path
            d="M22.8309 11.9118L19.3015 15.4412M22.8309 11.9118L26.3604 15.4412M22.8309 11.9118V23.9118M18.4192 19.6765H15.3898C15.1136 19.6765 14.8898 19.9003 14.8898 20.1765V30.6471C14.8898 30.9232 15.1136 31.1471 15.3898 31.1471H30.2721C30.5483 31.1471 30.7721 30.9232 30.7721 30.6471V20.1765C30.7721 19.9003 30.5483 19.6765 30.2721 19.6765H27.2427"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
